export const rrcpDashboardRoutes = {
	parent: '/home',
	downloadFile: 'download-file',
	prcInventory: 'prc-inventory',
	regulationChange: 'regulation-change',
	riskChange: 'risk-change',
	mappingEngine: 'mapping-engine',
	changeEngine: 'change-engine',
	dataIngestion: 'data-ingestion',
	riskQuantification: 'risk-quantification',
	grcModifiedChanges: 'modified-changes',
	testing: 'testing',
	testingHub: 'testing-hub',
	testScriptHub: 'test-script-hub',
	reporting: 'reporting',
	management: 'management',
	dataIngestionStagingData: '/data-ingestion/staging-data',
	entityId: ':entityId',
	controlDeDuplication: 'control-de-duplication',
	deDuplicationClusterReview: 'cluster-reviews',
	aimodels: 'ai-models',
	reportingLibraryDetail: 'report',
	reportId: ':reportId',
	regulationInventory: 'requirement-inventory',
	regulatoryApplicability: 'applicability',
	regulatoryGroupAssessment: 'group-assessment',
	regulationSummaryAssessment: 'summary',
	regulationMappingAssessment: 'mapping',
	regulatoryGroupReview: 'group-review',
	regulationMappingRegId: ':regulationId',
	subPartId: ':subPartId',
	groupId: ':groupId',
	overView: 'overview',
	simulationArena: 'simulation-arena',
	generate: 'generate',
	simulationType: ':simulationType',
	obligationAndControl: 'regulation-obligation-control',
	obligationToPolicy: 'obligation-to-policy',
	plainEnglishSummary: 'plain-english-summary',
	regulationSummary: 'regulation-summary',
	riskStatement: 'risk-statement',
	controlObjective: 'control-objective',
	controlStatement: 'control-statement',
	controlTestScripts: 'control-test-scripts',
	controlQualityGrammerCheck: 'quality-and-grammar-check',
	controlQuality: 'quality-check',
	unauthorized: 'unauthorized',
	horizonScanning: 'horizon-scanning',
	horizonScanningDetail: 'horizon-scanning-detail',
	citation: 'citation',
	uploadParser: 'upload-parser',
};
